<div style="margin-bottom: 12px;">
  <button (click)="toggleAges()" style="padding: 6px 12px; cursor: pointer;">
    Переключить возраст (совершеннолетние ↔ несовершеннолетние)
  </button>
  <p style="margin: 6px 0 0; color: #666; max-width: 760px;">
    Клик заменяет <code>[tableData]</code> новым массивом новых объектов (как ответ REST):
    статус-иконка / цвет / tooltip / код действия пересчитываются (фикс #1/#3).
    У несовершеннолетних действие «удалить» и пункт меню «В&nbsp;архив» становятся
    disabled — их цвет (красный / фиолетовый) гаснет в нейтральный disabled-цвет (фикс #2).
  </p>
</div>

<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
  (rowAction)="onRowActions($event)"
></aur-mat-table>
